/* eslint-disable max-lines */
/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import TextField from '@base/TextField/TextField';
import { breakpoints, Fonts, Spacings, mediaQuery } from '@styles/index';
import NumberField from '@base/NumberField/NumberField';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import H5 from '@base/H5/H5';
import Button from '@base/Button/Button';
import Dropdown from '@comp/Dropdown/Dropdown';
import Divider from '@base/Divider/Divider';
import Checkbox from '@base/Checkbox/Checkbox';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import H3 from '@base/H3/H3';

export const Img = styled.img`
  user-drag: none;
  user-select: none;
`;

export const OuterContainer = styled.div`
  background: linear-gradient(
    180deg,
    var(--color-i-blue-11) 0%,
    var(--color-i-white) 100%
  );
  margin-bottom: -${Spacings.SPACING_10B};
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: ${Spacings.SPACING_4B};
  padding-top: ${Spacings.SPACING_18B};
  width: 1136px;
  margin: auto;
  ${mediaQuery.uptoTablet} {
    width: 728px;
  }
  ${mediaQuery.uptoMobile} {
    display: grid;
    width: 100%;
    padding-top: ${Spacings.SPACING_14B};
    column-gap: 0;
    margin-top: 0;
  }
`;

export const Title = styled.h1`
  margin: 0;
  max-width: 412px;
  margin-top: ${Spacings.SPACING_8B};
  font-size: 40px;
  line-height: ${Spacings.SPACING_12B};
  color: var(--color-i-black);
  ${mediaQuery.aboveTablet} {
    margin-bottom: ${Spacings.SPACING_10B};
  }
  ${mediaQuery.uptoTablet} {
    margin-bottom: ${Spacings.SPACING_3B};
    font-size: ${Spacings.SPACING_8B};
    line-height: 38.4px;
    max-width: 260px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: ${Spacings.SPACING_7B};
    margin-top: ${Spacings.SPACING_6B};
    margin-bottom: ${Spacings.SPACING_6B};
    line-height: 33.6px;
    max-width: 100%;
  }
`;

// Form styles

export const FormContainer = styled.form`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.aboveMobile} {
    margin-top: ${Spacings.SPACING_6B};
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

export const SubFormContainer = styled.form`
  ${mediaQuery.aboveMobile} {
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

export const ContinueButon = styled(Button)`
  margin-top: ${Spacings.SPACING_8B};
`;

export const StyP2 = styled(P2)`
  display: inline-block;
`;

export const StyledPaper = styled(Paper)`
  border: 1px solid var(--color-divider);
  box-shadow: 0px ${Spacings.SPACING_2B} ${Spacings.SPACING_4B}
    rgba(221, 230, 237, 0.4);
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  ${mediaQuery.aboveTablet} {
    max-width: 464px;
    padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_6B};
    grid-column: 13/23;
    margin: 0px;
  }
  ${mediaQuery.uptoTablet} {
    grid-column: 12/25;
  }
  ${mediaQuery.uptoMobile} {
    margin: 0;
  }
`;

const H1 = styled.h1`
  color: var(--color-i-black);
  margin: 0;
`;

export const ClassTitle = styled(H1)`
  font-size: ${Fonts.H4};
  line-height: ${Spacings.SPACING_6B};
  margin-bottom: ${({ $subTitle }) => ($subTitle ? '2px' : '0px')};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_6B};
    margin-bottom: ${Spacings.SPACING_3B};
  }
`;

export const ClassSubTitle = styled.h3`
  font-size: ${Fonts.H7};
  line-height: 18px;
  color: var(--color-i-orange-1);
  margin-left: ${Spacings.SPACING_1B};
  margin-bottom: 0;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const BookAClassForm = styled.div`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
`;

export const PostPaymentFormContainer = styled.div`
  padding-top: ${Spacings.SPACING_20B};
  @media only screen and (min-width: ${breakpoints.mobile}) {
    grid-column: 13/25;
  }
  ${mediaQuery.uptoMobile} {
    grid-column: 1/25 !important;
    grid-row: 1;
    width: 100%;
    padding: ${Spacings.SPACING_10B} ${Spacings.SPACING_4B};
  }
`;

export const FormSubHeading = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubHeading = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    align-items: flex-start;
  }
`;

export const StyledSpan = styled.span`
  color: var(--color-text-primary);
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H5};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

export const StyledSubSpan = styled.span`
  color: var(--color-text-secondary);
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.H5};
`;
export const StyledP2 = styled(P2)`
  margin-left: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.LARGE};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;
export const FormHeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${mediaQuery.uptoMobile} {
    flex-direction: column-reverse;
    justify-content: space-between;
  }
`;

export const StyledStepHeading = styled(P1)`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.LARGE};
  color: var(--color-text-secondary);
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const Input = styled.input`
  display: none;
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  font-size: ${Fonts.H6};
  line-height: 50%;
  font-weight: ${Fonts.SEMIBOLD};
  &.MuiOutlinedInput-root {
    width: 100%;
    height: ${Spacings.SPACING_14B};
    border-radius: ${Spacings.SPACING_2B};
    border: 1px solid var(--color-i-gray-14);
    ${mediaQuery.uptoMobile} {
      height: ${Spacings.SPACING_12B};
    }
    .MuiOutlinedInput-input {
      width: 100%;
      padding: ${Spacings.SPACING_4B} 14px;
      height: ${Spacings.SPACING_5B};
    }
  }
  &.MuiOutlinedInput-root .MuiOutlinedInput-input.Mui-disabled {
    height: ${Spacings.SPACING_6B};
    border-radius: ${Spacings.SPACING_2B};
    ${mediaQuery.uptoMobile} {
      height: ${Spacings.SPACING_4B};
    }
  }
`;

export const StyledTextFieldFlex = styled(TextField)`
  width: 100%;
  font-size: ${Fonts.H6};
  line-height: 50%;
  font-weight: ${Fonts.SEMIBOLD};
  &.MuiOutlinedInput-root {
    width: 204px;
    height: ${Spacings.SPACING_14B};
    border-radius: ${Spacings.SPACING_2B};
    border: 1px solid var(--color-i-gray-14);
    ${mediaQuery.uptoMobile} {
      width: 100%;
      height: ${Spacings.SPACING_12B};
    }
    .MuiOutlinedInput-input {
      width: 100%;
      padding: ${Spacings.SPACING_4B} 14px;
      height: ${Spacings.SPACING_5B};
    }
  }
`;

export const StyledTerms = styled(P2)`
  margin-top: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_3B};
  color: var(--color-i-gray);
`;

export const StyledTermsSpan = styled.span`
  color: var(--color-text-primary);
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.ULTRA_SMALL};
  cursor: pointer;
`;
export const FormSectionHeading = styled(H5)`
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_6B};
  }
`;

export const FormSectionSubHeading = styled(P1)`
  margin-top: ${Spacings.SPACING_4B};
`;

export const FieldWrapper = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

export const FieldWrapperSmall = styled.div`
  margin-top: ${Spacings.SPACING_3B};
`;

export const FieldWrapperFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const Error = styled(P2)`
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-i-red);
  margin-top: ${Spacings.SPACING_2B};
`;

export const StyledNumberField = styled(NumberField)`
  width: 100%;
  font-size: ${Fonts.H6};
  line-height: 50%;
  font-weight: ${Fonts.SEMIBOLD};
  &.MuiOutlinedInput-root {
    width: 100%;
    height: ${Spacings.SPACING_14B};
    ${({ disabled }) =>
      disabled ? ' background-color: var(--color-divider);' : null}
    ${mediaQuery.uptoMobile} {
      height: ${Spacings.SPACING_12B};
    }
    .MuiOutlinedInput-input {
      width: 100%;
      padding: ${Spacings.SPACING_4B} 14px;
    }
  }
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
  }
`;

export const StyledNumberFieldFlex = styled(NumberField)`
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.SEMIBOLD};
  line-height: 50%;
  margin-left: 8px;
  ${mediaQuery.uptoMobile} {
    margin-left: 0px;
    font-size: ${Fonts.H7};
  }
  &.MuiOutlinedInput-root {
    width: 204px !important;
    height: ${Spacings.SPACING_14B};
    ${mediaQuery.uptoMobile} {
      width: 100% !important;
      height: ${Spacings.SPACING_12B};
    }
    .MuiOutlinedInput-input {
      width: 100%;
      padding: ${Spacings.SPACING_4B} 14px;
    }
  }
`;

export const StyledDropdown = styled(Dropdown)`
  border-color: var(--color-divider);
  padding: ${Spacings.SPACING_4B} 14px !important;
  height: ${Spacings.SPACING_14B};
  box-shadow: none;
  h6 {
    font-size: ${Fonts.SMALL};
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: ${Spacings.SPACING_12B};
  }
`;

export const StyledDivider = styled(Divider)`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

export const CheckboxWrapper = styled.div`
  margin-top: ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StyledCheckbox = styled(Checkbox)`
  font-weight: ${Fonts.LIGHT};
  &.MuiTypography-body1 {
    font-size: ${Fonts.SMALL};
  }
`;

export const CheckboxLabel = styled(P1)`
  display: inline;
  cursor: pointer;
  user-select: none;
`;

export const ThankYouCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  grid-column: 5/20;
  margin-top: ${Spacings.SPACING_25B};
  height: 359px;
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
`;

export const CoverWrapper = styled.div`
  margin-top: ${Spacings.SPACING_20B};
  grid-column: 3/12;
  ${mediaQuery.uptoTablet} {
    grid-column: 1/11;
  }
  ${mediaQuery.uptoMobile} {
    grid-column: 1/25;
    grid-row: 2;
    margin-top: 0px;
    max-width: 100%;
    width: 100%;
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B}
      ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
  }
`;

export const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_5B};
  }
`;

export const StyledCenterDivider = styled(Divider)`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_5B};
  }
`;

export const ContentWrapper = styled.div``;

export const StyledP1 = styled(P1)`
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_6B};
`;

export const StyledSecP1 = styled(P1)`
  margin-bottom: ${Spacings.SPACING_6B};
  font-weight: ${Fonts.SEMIBOLD};
  max-width: 237px;
  margin-left: ${Spacings.SPACING_2B};
`;

export const ContentLineWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ImageWrapper = styled.div`
  width: auto;
  height: 236px;
  position: relative;
`;
